import { StoreSlice } from '..'

export interface CreatePropertyAdSliceFields {
  steps: number
  currentStep: number
  setStep: (value: number) => void
  completedSteps: string[]
  setCompletedSteps: (value: string[]) => void
  completeStep: (stepId: string) => void
  uncompleteStep: (stepId: string) => void
  validSteps: string[]
  setValidSteps: (value: string[]) => void
  validateStep: (stepId: string) => void
  invalidateStep: (stepId: string) => void
  invalidSteps: string[]
  setStepInvalid: (stepId: string) => void
  unsetStepInvalid: (stepId: string) => void
  locale: string
  setLocale: (value: string) => void
  resetForm: () => void
}

export const CreatePropertyAdSlice: StoreSlice<CreatePropertyAdSliceFields> = (
  set,
  get
) => ({
  steps: 4,
  currentStep: 0,
  setStep: (value) =>
    set({
      currentStep: value,
    }),
  completedSteps: [],
  setCompletedSteps: (value: string[]) =>
    set({
      completedSteps: value,
    }),
  completeStep: (stepId) => {
    const { completedSteps } = get()
    if (!completedSteps.includes(stepId)) {
      set({
        completedSteps: [...completedSteps, stepId],
      })
    }
  },
  uncompleteStep: (stepId) => {
    const { completedSteps } = get()
    if (completedSteps.includes(stepId)) {
      set({
        completedSteps: completedSteps.filter((item) => item !== stepId),
      })
    }
  },
  validSteps: [],
  setValidSteps: (value: string[]) =>
    set({
      validSteps: value,
    }),
  validateStep: (stepId) => {
    const { validSteps } = get()
    if (!validSteps.includes(stepId)) {
      set({
        validSteps: [...validSteps, stepId],
      })
    }
  },
  invalidateStep: (stepId) => {
    const { validSteps } = get()
    if (validSteps.includes(stepId)) {
      set({
        validSteps: validSteps.filter((item) => item !== stepId),
      })
    }
  },
  invalidSteps: [],
  setStepInvalid: (stepId) => {
    const { invalidSteps } = get()
    if (!invalidSteps.includes(stepId)) {
      set({
        invalidSteps: [...invalidSteps, stepId],
      })
    }
  },
  unsetStepInvalid: (stepId) => {
    const { invalidSteps } = get()
    if (invalidSteps.includes(stepId)) {
      set({
        invalidSteps: invalidSteps.filter((item) => item !== stepId),
      })
    }
  },
  locale: 'el',
  setLocale: (value) => {
    set({
      locale: value,
    })
  },
  resetForm: () => {
    set({
      completedSteps: [],
      validSteps: [],
      invalidSteps: [],
      currentStep: 0,
    })
  },
})
